export default __webpack_public_path__ + "static/media/Our-Choose.ab25fd31.webp";